export default __webpack_public_path__ + "static/assets/671d2935ea92ec704509e5ada44a1466.png";